import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import emitter from '../../setup/bus';
import { i18n } from '../../setup/i18n';

export default function initNewsHub() {
    const pinia = createPinia();
    const app = createApp({});
    app.config.globalProperties.$bus = emitter;
    app.provide('$bus', emitter);
    app.use(pinia)
        .use(i18n)
        .component(
            'NewsHub',
            defineAsyncComponent(() => import('./NewsHub.vue'))
        )
        .component(
            'SkeletonLoader',
            defineAsyncComponent(() => import('./components/SkeletonLoader.vue'))
        )
        .component(
            'NewsCard',
            defineAsyncComponent(() => import('./components/NewsCard.vue'))
        )
        .component(
            'Spinner',
            defineAsyncComponent(() => import('../LoadingSpinner/LoadingSpinner.vue'))
        )
        .mount('#news-hub-container');
}
